import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import CurrentPlan from "../../components/user/billing/CurrentPlan";
import BillingDetails from "../../components/user/billing/BillingDetails";
import BillingReport from "../../components/user/billing/BillingReport";
import BackButton from "../../components/BackButton";


function Billing() {

  return (
    <>
      <AppWrapper
        pagename={"settings"}
        route={"upgrade"}
      >
        <StyledBilling>
          <Title title={"Billing"}
            btnName={"Packages"}
            link={'/user/settings/packages'}
          />

          <BackButton />
          <div className="main-container">
            <CurrentPlan />
          </div>
          <div className="main-container mt-5">
            <BillingDetails />
          </div>
          <div className="main-container mt-5">
            <BillingReport />
          </div>


        </StyledBilling>


      </AppWrapper>

    </>
  );
}

export default Billing;

const StyledBilling = styled.div`
  

`;